module.exports = new __parcel__URL__("mushmi.0e1830c2.png").toString();